
import { mapState } from 'vuex'
import { HexToRGB } from '~/utils/utils.js'
export default {
  inject: ['detail'],
  data() {
    const _lbl = []
    return {
      widthType: 'pc',
      lbl: _lbl,
      lan: this.$store.state.LanguageCode,
      zk_show: false,
      zk: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      contentcookie: 'contentcookie'
    })
  },
  mounted() {
    console.log('detail-company-detail', this.detail)
    this.getelewidth()
    this.initeLabelStyle()
  },
  methods: {
    TransColor(color, tm) {
      if (!color) {
        return ''
      } else {
        return HexToRGB(color, tm)
      }
    },
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth()) this.widthType = 'pc'
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth()) this.widthType = 'lg'
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth()) this.widthType = 'md'
      else this.widthType = 'sm'
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
    initeLabelStyle() {
      const Dom = document.getElementsByClassName('tagGroup_Comp')
      const subDom = document.getElementsByClassName('tagitem_Comp')
      if (subDom && subDom.length) {
        let currWidth = 0
        for (let i = 0; i < subDom.length; i++) {
          currWidth += subDom[i].clientWidth + 8
        }
        this.zk_show = currWidth > Dom[0].clientWidth - 21
      }
    },
    changeIconShow() {
      this.zk = !this.zk
    }
  }
}
